/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Backend-driven auto-sync outcome attached to mutation responses.
 *
 * Present (non-null) only when the job's ATS link opts into auto-sync; a
 * null value means auto-sync did not run (unlinked job or setting off).
 */
export interface AutoSyncCounts {
  queued?: number;
  skipped_insufficient_credits?: number;
  skipped_blocked?: number;
}
